import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import DefinitionCard from './DefinitionCard';
import { sustainabilityPillars } from './definitionData';
import './Definition.css';

export default function Sustainability() {
    return (
        <section id="definition" className="">
            <Container fluid>
                <Row className="definition-block px-3">
                    <Col className="">
                        <h2 className="definition-title text-center  h1  text-primary">
                            What is Sustainability?
                        </h2>
                        <p className="definition-subtitle fs-3 ">
                            Sustainability is the capacity to maintain and
                            balance <b>environmental, economic, and social </b>{' '}
                            systems over the long term, ensuring that current
                            needs are met without compromising the ability of
                            future generations to meet their own needs.
                        </p>
                    </Col>
                </Row>
                <Row className="system-cards-block">
                    <Col className="system-cards-container">
                        {sustainabilityPillars.map((pillar) => (
                            <Col key={pillar.id}>
                                <DefinitionCard
                                    title={pillar.title}
                                    description={pillar.description}
                                    imgSrc={pillar.imgSrc}
                                />
                            </Col>
                        ))}
                    </Col>
                </Row>
                <Row className="system-cards-block-background" />
            </Container>
        </section>
    );
}
